/***
**Module Name: add user
 **File Name :  adduser.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains add user details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from "moment";

import { useHistory, Link } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import axios from 'axios';
let { appname, lambda, country } = window.app;


const AddUser = () => {
    const history = useHistory();
    const [files, setFiles] = useState([]);
    const [success, setSuccess] = useState(false);
    const [quizInfo, setQuizInfo] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
       // startDate: "",
        endDate: "",
        quizType: "",
        status: ""
    });
    const[uploadImg,setUploadImg]=useState('');
    const[filesData,setFilesData]=useState([])
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);
    const [fileSizeError, setFileSizeError] = useState(false);

    const[dynamicQuizId, setQuizId]=useState(null);

    const { route, setRoute, setCurrentPage, setRowsPerPage, usePrevious, GetTimeActivity } = useContext(contentContext);

    const prevRoute = usePrevious(route)
    const now = new Date();
    // Subtract 1 hour from the current time
    now.setMinutes(now.getMinutes() + 5);
    // Format the date and time to match the "datetime-local" input
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const currentDateTimeOneHour = `${year}-${month}-${day}T${hours}:${minutes}`;
    // console.log(currentDateTimeOneHour, 'cc');


    useEffect(() => {
        if (prevRoute != undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            history.push("/admin");
        }
    }, []);

    const handleBack = (e) => {
        GetTimeActivity()
        history.push("/admin/dashboard");
    }


    const handleAddQuiz = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();

        if (isValid) {
         uploadFile();
        }
    }
    function formvalidation() {
        // GetTimeActivity()
        let formIsValid = true;

        // console.log('form', formData, currentDateTimeOneHour)
        if (formData?.name == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "Please enter quiz name", // Update the changed field
            }));
            seterrorDisplay(true)
            // setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "", // Update the changed field
            }));
        }

        if (formData?.quizType == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["quizType"]: "Please select quiz type", // Update the changed field
            }));
            seterrorDisplay(true)
            // setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["quizType"]: "", // Update the changed field
            }));
        }

        if (formData?.status == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["status"]: "Please select status", // Update the changed field
            }));
            seterrorDisplay(true)
            // setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["status"]: "", // Update the changed field
            }));
        }

        // console.log(formData?.startDate, 'fomrstartdate')
        // const formStartDate = new Date(formData?.startDate);
        // const currentDateTime = new Date(currentDateTimeOneHour);


       // console.log(formStartDate, currentDateTime, 'ttsssasaa')
        // if (formData?.startDate == "") {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["startDate"]: "Please select startdate", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     //  setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } else if (formStartDate < currentDateTime) {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["startDate"]: "Please select start time 5minutes greater than current time", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     // setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } else {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["startDate"]: "", // Update the changed field
        //     }));
        // }

        if (formData?.quizType == "Competitive" && formData?.endDate == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["endDate"]: "Please select enddate", // Update the changed field
            }));
            seterrorDisplay(true)
            //  setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } 
        // else if (formData?.endDate < formData?.startDate) {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["endDate"]: "Please select enddate greater than startdate", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     //   setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } 
        else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["endDate"]: "", // Update the changed field
            }));
        }
        // setTimeout(function () { seterrorDisplay(false) }, 3000);
        return formIsValid;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
    };

    const handleReset = (event) => {

        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            name: "",
            startDate: "",
            endDate: "",
            quizType:""
        }));
        setUploadImg("")
    };



    const createQuiz = async (filesData, quizId) => {
       
        try {
            if (filesData && filesData.length > 0) {
                formData["files"] = filesData
            }
            if(quizId){
                formData["quizid"] = quizId
            }

            const response = await tmdbApi.AddQuiz(formData);
            // console.log(response);
            setQuizInfo(response?.result)
            // if (response?.statusCode == 200) {
            setSuccess(true);
            //  }
        } catch {
            console.log("error");
        }
    };


    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
        // history.push("/admin/dashboard")
        history.push("/admin/addquestion/" + dynamicQuizId);
        // window.location.reload()
    };

    // const handleBread = () => {
    //     GetTimeActivity()
    //     history.push("/usermanagement")
    //    // history.push("/admin/addquestion/" + quizInfo?.quizid);
    //     // admin/addquestion/:id`
    // }
    const uploadFile=async()=>{
        let ObjectIDQuiz = require("bson-objectid");
        let quizId = new ObjectIDQuiz().toString();
        setQuizId(quizId)
        if(filesData && filesData?.length > 0){
            
            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${quizId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window.site.common.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]
                    const updatedFiles = [...files, ...newFile];
        
                    setFiles(updatedFiles);
                    createQuiz(updatedFiles, quizId);
                    const uploadPromise = axios.post(
                        `${lambda}/uploadFiles?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            return axios.put(uploadUrl, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    // setFiles([...files, ...newFile]); 
                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }else {
            createQuiz([], quizId);
        }

    }

    const handleFileChange =  (event) => {
        const selectedFile = event.target.files[0];
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files
        // const selectedFilesSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);  //for multiple files
        console.log("selectedFile ", selectedFile)
        console.log("selectedFiles ", selectedFiles)

        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile?.size < fileSize) {
            if (selectedFile) {
                // Create a preview URL for the image
                const previewUrl = URL.createObjectURL(selectedFile);
                setUploadImg(previewUrl); // Store the URL in state
            }
            setFilesData(selectedFiles)
        }else {
            setFileSizeError(true)
        }
       

        // setFiles([...files, ...selectedFiles]); //for multiple files

        // console.log("files ", files)

       
    };
   const handleRemove =()=>{
    setUploadImg("")
    setFilesData([])
   }

    // console.log('uploadImggggggggggg ', uploadImg)
    // console.log(quizInfo, new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":")))
    return (
        <>

            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="quiz-page main-content user-management create-user">

                    <div className="page-content ">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">

                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Create Quiz</h4>
                                            <p className="menu-path"><span>Quiz </span> / <b>Create Quiz</b></p>

                                        </div>
                                        <div>
                                            <a onClick={handleBack} className="btn btn-primary">back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="create-user-block">
                                <div className="form-block">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="col-md-12">
                                                <div className="mb-3 input-field">
                                                    <label className="form-label form-label">QUIZ NAME</label>
                                                    <input id="name" name="name" placeholder="Enter quiz name" type="text" className="form-control form-control" aria-invalid="false" onChange={handleChange} value={formData?.name} />

                                                    {errorDisplay && <span className="errormsg" style={{
                                                        fontWeight: 'bold',
                                                        color: 'red',
                                                    }}>{errorData?.name}</span>}

                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 input-field">
                                                    <label className="form-label form-label">QUIZ TYPE</label>
                                                    <select name="quizType" onChange={handleChange} value={formData?.quizType} className="form-control">
                                                        <option value="">Select Type</option>
                                                        <option value="Self Assessment">Self Assessment</option>
                                                        <option value="Competitive">Competitive</option>
                                                    </select>


                                                    {errorDisplay && <span className="errormsg" style={{
                                                        fontWeight: 'bold',
                                                        color: 'red',
                                                    }}>{errorData?.quizType}</span>}
                                                </div>
                                            </div>

                                           {formData?.quizType == "Competitive" &&
                                            <div className="col-md-6">
                                                <div className="mb-3 input-field">
                                                    <label className="form-label form-label">END DATE</label>
                                                    <input type="datetime-local" name="endDate" className="form-control form-control" aria-invalid="false" onChange={handleChange} min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.endDate} />

                                                    {errorDisplay && <span className="errormsg" style={{
                                                        fontWeight: 'bold',
                                                        color: 'red',
                                                    }}>{errorData?.endDate}</span>}
                                                </div>
                                            </div>}

                                            <div className="col-md-6">
                                                <div className="mb-3 input-field">
                                                    <label className="form-label form-label">STATUS</label>
                                                    <select name="status" onChange={handleChange} value={formData?.status} className="form-control">
                                                        <option value="">Select Status</option>
                                                        <option value="ACTIVE">ACTIVE</option>
                                                        <option value="INACTIVE">INACTIVE</option>
                                                    </select>


                                                    {errorDisplay && <span className="errormsg" style={{
                                                        fontWeight: 'bold',
                                                        color: 'red',
                                                    }}>{errorData?.status}</span>}
                                                </div>
                                            </div>

                                            {/* <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">START DATE</label>
                                                        <input type="datetime-local" name="startDate" className="form-control form-control" aria-invalid="false" onChange={handleChange} min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.startDate} />

                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.startDate}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">END DATE</label>
                                                        <input type="datetime-local" name="endDate" className="form-control form-control" aria-invalid="false" onChange={handleChange} min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.endDate} />

                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.endDate}</span>}
                                                    </div>
                                                </div>
                                            </div> */}

                                            

                                           
                                           
                                            <div className="col-md-6">
                                                <div className="mb-3 input-field">
                                                    <label className="form-label form-label">UPLOAD IMAGE</label>
                                                    <div className="upload-zone">
                                                         {uploadImg?
                                                           <div className="upload-icon ">
                                                           <div className="img_block add_img_block">
                                                           <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove}>close</span>
                                                               <img id="activimg" src={uploadImg} width={150} />
                                                           </div>
                                                           </div>:
                                                            <>

                                                            <div className="file_upload">
                                                                <span className="material-symbols-outlined icon"> upload_file </span>
                                                                <input
                                                                    type="file"
                                                                    id="file-upload"
                                                                    accept="image/jpeg, image/png"
                                                                    className="file-input"
                                                                    multiple={false}
                                                                    onChange={handleFileChange}
                                                                    style={{ display: 'none' }}
                                                                />

                                                                <label
                                                                    htmlFor="file-upload"
                                                                    className="stroke-btn btn btn-primary rounded-pill px-3 py-2 mb-2 mb-lg-0 mt-3"
                                                                >
                                                                    Select file
                                                                </label>
                                                            </div>
                                                            <div className="file_requirements ">
                                                                <p>Maximum file size: 5MB</p>
                                                                <p>Supported formats: JPG, PNG</p>
                                                            </div></>
                                                                
                                                         }
                                                      

                                                      

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <button className="btn btn-primary btn-block btn1 " type="submit" onClick={e => handleAddQuiz(e)}>Create Quiz</button>
                                        <button className="btn btn-primary btn-block btn2 " onClick={e => handleReset(e)}>Reset</button>
                                    </div>
                                </div>
                                <SweetAlert show={success}
                                    custom
                                    confirmBtnText="ok"
                                    confirmBtnBsStyle="primary"
                                    title={"Quiz created successfully"}
                                    onConfirm={e => onConfirm()}
                                >
                                </SweetAlert>

                                <SweetAlert show={fileSizeError}
                                    warning
                                    confirmBtnText="ok"
                                    confirmBtnBsStyle="danger"
                                    title={"File size greater than 5MB"}
                                    onConfirm={e => setFileSizeError(false)}
                                >
                                </SweetAlert>
                            </div>


                        </div>
                    </div>



                    <Footer />
                </div>


            </div>

        </>
    );
};

export default AddUser;
